import React from 'react';

// @ts-ignore
import * as styles from './InfoSection.module.scss';

export function InfoSection() {
  return (
    <div className={styles.InfoWrapper}>
      <div className={styles.InfoIcon}>!</div>
      <p className={styles.InfoText}>
        You can click on items in the graph's legend to hide that data point. If
        you want to isolate one data point, click all the others to temporarily
        hide them.
      </p>
    </div>
  );
}
